var React = require('react');

function Door (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_168","data-name":"Group 168","transform":"translate(-702.846 -2156.886)"},[React.createElement("path",{"id":"Path_582","data-name":"Path 582","d":"M750.811,2163.225H743.18v4.36h4.361v56.686H743.18v4.36h7.631a1.09,1.09,0,0,0,1.09-1.09v-63.226A1.09,1.09,0,0,0,750.811,2163.225Z","fill":"#606060","key":0}),React.createElement("path",{"id":"Path_583","data-name":"Path 583","d":"M739.726,2156.9l-35.974,6.167a1.09,1.09,0,0,0-.906,1.075v63.568a1.091,1.091,0,0,0,.906,1.075l35.974,6.167a1.09,1.09,0,0,0,1.274-1.075v-75.9A1.09,1.09,0,0,0,739.726,2156.9Zm-3.679,40.934a1.908,1.908,0,1,1,1.908-1.908A1.907,1.907,0,0,1,736.047,2197.836Z","fill":"#606060","key":1})]));
}

Door.defaultProps = {"width":"50px","height":"50px","viewBox":"0 0 49.055 78.084"};

module.exports = Door;

Door.default = Door;
